import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Programs from "@/components/site/Programs";
import Impact from "@/components/site/Impact";
import StoriesPage from "@/pages/StoriesPage";
import TeamPage from "@/pages/TeamPage";
import HeaderLab from "@/pages/HeaderLab";
import StoriesTeaser from "@/components/site/StoriesTeaser";
import GetInvolved from "@/components/site/GetInvolved";
import NeedSupport from "@/components/site/NeedSupport";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import DonateDialog from "@/components/site/DonateDialog";
import DonateFAB from "@/components/site/DonateFAB";

function Home() {
  const [donateOpen, setDonateOpen] = useState(false);
  const openDonate = () => setDonateOpen(true);
  const closeDonate = () => setDonateOpen(false);

  useEffect(() => {
    if (donateOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [donateOpen]);

  return (
    <div data-testid="site-home" className="App">
      <Header onDonate={openDonate} />
      <main>
        <Hero onDonate={openDonate} />
        <About />
        <Programs />
        <Impact />
        <StoriesTeaser />
        <NeedSupport />
        <GetInvolved onDonate={openDonate} />
        <Contact />
      </main>
      <Footer onDonate={openDonate} />
      <DonateFAB onClick={openDonate} />
      <DonateDialog open={donateOpen} onClose={closeDonate} />
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/header-lab" element={<HeaderLab />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
